// ✅ PREMIUM / FULL DETAIL / KO+EN (1~12)
// - 과학(호르몬) “단정” 제거 → ‘비유적 축(Drive/Vigilance)’로 정리
// - S/E 축과 동일한 프리미엄 필드 구조로 통일
// - 1~12 각각: deepDive / triggers / loops / scripts / repair / growth 포함

export const B_AXIS_SYSTEM_INTRO = {
    ko: {
        drive: {
            title: "Drive(추진력): 목표를 밀어붙이는 ‘행동 엔진’",
            desc: "이 축에서 말하는 Drive는 실제 호르몬 수치가 아니라, ‘목표를 향해 움직이려는 추진 에너지’의 비유입니다. 문제를 만나면 멈추기보다 전진하고, 결론을 만들고, 성취로 증명하려는 패턴이 강해집니다.",
            strong: "강할수록 실행·돌파·결단이 빠르고, 관계에서도 ‘해결/개선’에 에너지를 투입합니다.",
            love: "단, 속도·기준·노력의 강도가 상대를 압도할 수 있어 ‘페이스 조절’이 핵심입니다."
        },
        vigilance: {
            title: "Vigilance(경계): 안전을 확보하는 ‘리스크 레이더’",
            desc: "Vigilance는 ‘위험을 피하고 질서를 유지하려는 경계/불안 시스템’의 비유입니다. 규칙을 지키는 이유가 ‘신념’인지 ‘불안 회피’인지에 따라 관계의 질감이 달라집니다.",
            strong: "강할수록 대비·통제·예측 가능성이 높아지지만, 과하면 강박·불안·회피로 흐를 수 있습니다.",
            love: "갈등에서의 회피, 완벽주의, 과도한 자기검열로 나타날 수 있어 ‘안전한 실패 경험’이 중요합니다."
        }
    },
    en: {
        drive: {
            title: "Drive: The ‘Action Engine’ that pushes goals forward",
            desc: "In this model, Drive is not a medical claim. It’s a metaphor for your forward force—how strongly you move toward goals, closure, and proof through action.",
            strong: "When strong, you execute fast, decide quickly, and invest energy into improving the relationship.",
            love: "But if your pace becomes the standard, your partner may feel pressured—pace-matching is the key skill."
        },
        vigilance: {
            title: "Vigilance: The ‘Risk Radar’ that protects safety",
            desc: "Vigilance is a metaphor for your safety-seeking system—how strongly you monitor risk, preserve order, and avoid threat. It shapes whether rules come from conviction or fear.",
            strong: "When strong, you’re prepared and consistent, but excess can become anxiety, compulsion, or avoidance.",
            love: "It can show up as conflict avoidance, perfection pressure, and self-criticism—healthy ‘safe failure’ practice matters."
        }
    }
};

export const B_AXIS_DATA = {
    ko: {
        1: {
            title: "원칙의 수호자 (The Pillar of Principles)",
            summary: "원칙이 ‘성격’이 아니라 ‘정체성’인 타입",
            analysis: "기준이 뚜렷하고 실행도 강하다. 다만 ‘실수=배신’으로 번역되면 관계가 숨 막힌다.",
            deepDive:
                "당신에게 원칙은 단순한 규칙이 아니라 ‘나를 지탱하는 구조’입니다. 그래서 약속을 지키는 건 선행이 아니라 기본값이고, 사소한 위반도 ‘행동 오류’가 아니라 ‘신뢰 균열’로 들어옵니다. 장점은 예측 가능성과 신뢰의 강도. 단점은 기준이 너무 단단할 때 상대가 숨을 못 쉬는 것.",
            triggerMap: ["사소한 거짓말", "약속 미이행", "‘이 정도는 괜찮잖아’ 합리화", "무례/비윤리적 행동(작은 규칙 위반 포함)"],
            innerMonologue: ["“이건 실수가 아니라 기준의 문제야.”", "“신뢰는 한 번 깨지면 복구가 어렵다.”", "“나를 가볍게 본 건가?”"],
            relationshipLoop: "위반 감지 → 내부 신뢰 점수 급락 → 감정 거리 생성 → 상대는 갑작스런 냉각 체감 → ‘검열’ 분위기 고착",
            whatYouNeed: ["‘맥락 vs 악의’ 구분", "기준을 ‘법’이 아니라 ‘합의’로 운용", "수정 기회를 주는 여유"],
            whatPartnerNeeds: ["즉시 단죄 대신 설명 기회", "실수와 배신의 구분", "따뜻함(평가보다 감정 공유)"],
            doDont: {
                do: ["판정 전 의도 확인", "감정 먼저 공유(‘나는 이게 중요해’)", "재발 기준과 합의 만들기"],
                dont: ["실수=인격 문제로 확장", "침묵으로 처벌", "내 기준을 상대에게 강제"]
            },
            scripts: [
                "“이건 나한테 중요한 기준이야. 왜 그렇게 했는지 듣고 싶어.”",
                "“나는 원칙을 중요하게 생각해. 그래서 설명을 먼저 듣고 판단하고 싶어.”",
                "“실수면 고칠 수 있어. 반복이면 우리는 기준을 다시 정해야 해.”"
            ],
            repairProtocol: [
                "1) ‘나는 이게 중요해’(기준) + ‘그래서 서운해’(감정) 2문장으로 시작",
                "2) 의도 확인 질문 1개만: “왜 그렇게 했어?”",
                "3) 재발 방지 룰 1개 합의: “다음엔 ○○로 하자”",
                "4) 끝맺음: “지금은 다시 믿고 싶어” 같은 안심 문장 1개"
            ],
            growthPath: "판정 속도를 늦추고(1박), ‘설명→합의→회복’ 순서를 만들면 원칙은 유지한 채 관계도 부드러워진다.",
            loveInsight: "정직함은 숭고하지만, 관계는 법정이 아니라 살아 있는 생명체다."
        },

        2: {
            title: "불도저 추진가 (The Bulldozer)",
            summary: "문제 앞에서 멈추지 않는 고출력 돌파형",
            analysis: "실행·개선·돌파가 빠르다. 다만 속도가 ‘압박’으로 번역되면 파트너가 무력해진다.",
            deepDive:
                "당신은 갈등을 ‘회피할 불편함’이 아니라 ‘처리해야 할 과제’로 봅니다. 그래서 관계에서 문제를 만나면 압도적인 에너지로 밀어붙여 해결하려 합니다. 장점은 추진력과 책임감. 단점은 상대가 같은 속도로 움직이지 않을 때 ‘노력 부족’으로 판단하기 쉽다는 점.",
            triggerMap: ["답답한 미결 상태", "상대의 느린 반응", "반복되는 같은 문제", "‘노력’이 안 보인다고 느낄 때"],
            innerMonologue: ["“지금 해결하자.”", "“왜 이렇게 느려?”", "“이 정도는 같이 해야지.”"],
            relationshipLoop: "갈등 → 내가 즉시 해결 모드 → 상대는 압박/방어 → 속도 차로 감정 상처 → 더 큰 갈등",
            whatYouNeed: ["속도 조절(페이스 매칭)", "해결 전에 공감 1문장", "상대의 ‘회복 시간’ 존중"],
            whatPartnerNeeds: ["압박 아닌 협력", "결론 강요 대신 단계적 합의", "내 속도를 존중받는 느낌"],
            doDont: {
                do: ["‘지금은 안정, 다음은 해결’ 순서", "상대 보폭 확인 질문", "작은 합의부터 실행"],
                dont: ["‘왜 너는…’ 비교/비난", "결론 강요", "노력=사랑이라는 단선화"]
            },
            scripts: [
                "“나는 빨리 풀고 싶은데, 너 속도는 어때? 맞춰볼게.”",
                "“지금은 안정부터 만들자. 30분 뒤에 해결 얘기하자.”",
                "“내가 조급해졌어. 압박 주기 싫어.”"
            ],
            repairProtocol: [
                "1) 속도 선언: “내가 급해졌어”",
                "2) 페이스 질문: “너는 지금 어떤 속도가 가능해?”",
                "3) 오늘은 1개만 합의(나머진 다음 약속): ‘한 번에 끝장’ 금지",
                "4) 합의 후 칭찬: “너도 노력해줘서 고마워”"
            ],
            growthPath: "‘빠르게 푸는 능력’에 ‘천천히 기다리는 능력’이 더해지면, 압박이 아니라 리더십이 된다.",
            loveInsight: "혼자 달리면 경주다. 연애는 보폭을 맞추는 산책이다."
        },

        3: {
            title: "불안한 완벽주의자 (The Anxious Perfectionist)",
            summary: "기준은 높은데 실패 공포가 커서 방전/미루기가 생김",
            analysis: "도덕/기준은 높지만 실행 과정에서 불안이 과열된다. 회피와 죄책감 루프가 핵심 리스크.",
            deepDive:
                "당신은 ‘잘하고 싶은 마음’이 매우 크고, 기준도 높습니다. 그런데 기준이 높을수록 실패가 더 무서워져서 결정을 미루거나(프로크래스티네이션), 갈등에서 회피로 빠질 수 있습니다. 겉으로는 성실해 보이지만 속은 늘 ‘심판대’ 위에 서 있는 느낌.",
            triggerMap: ["갈등의 직면", "실수 지적", "기대에 못 미칠 것 같은 상황", "명확한 평가/판정의 느낌"],
            innerMonologue: ["“틀리면 끝이야.”", "“지금 말하면 더 망칠 것 같아.”", "“완벽히 하고 싶다…”"],
            relationshipLoop: "문제 발생 → 불안 상승 → 회피/미룸 → 죄책감 누적 → 자책/방전 → 관계 개선 더 어려움",
            whatYouNeed: ["완벽 대신 ‘충분히 좋음’", "작은 성공 경험(미션 쪼개기)", "갈등을 ‘실패’가 아니라 ‘조정’으로 재프레이밍"],
            whatPartnerNeeds: ["안전한 피드백(비난 아닌 협력)", "실수해도 버려지지 않는 확신", "작은 약속의 꾸준한 회복"],
            doDont: {
                do: ["5분 행동부터(작게 실행)", "불안 표현(‘지금 불안해’)", "갈등을 나눠서 대화하기"],
                dont: ["회피 후 자책만", "완벽한 타이밍만 기다리기", "상대 눈치를 ‘판정’으로 해석"]
            },
            scripts: [
                "“지금 불안해서 말이 꼬일 것 같아. 10분만 정리하고 다시 말할게.”",
                "“완벽하게 말은 못해도, 해결하고 싶어. 하나씩 해보자.”",
                "“내가 회피하면 죄책감만 쌓여. 오늘은 작은 것부터 하자.”"
            ],
            repairProtocol: [
                "1) 불안 표현: “지금 불안해서 말이 어려워”",
                "2) 15분 타이머 대화(짧게): 길게 끌지 않기",
                "3) ‘오늘 1개만’ 해결하고 종료",
                "4) 끝나면 작은 성공 체크: “오늘 이만큼 한 게 성과야”"
            ],
            growthPath: "완벽을 목표로 하지 말고 ‘작게 시작→작게 완료’ 루틴을 반복하면 불안이 줄고 실행이 살아난다.",
            loveInsight: "당신을 괴롭히는 건 상대가 아니라, 당신 안의 가상의 심판대다."
        },

        4: {
            title: "유연한 실용주의자 (The Flexible Pragmatist)",
            summary: "상황 최적화에 강한 현실형 — 기준이 흐리면 신뢰가 흔들릴 수 있음",
            analysis: "타협과 효율이 장점. 다만 ‘핵심 가치’가 없으면 가벼움으로 오해받는다.",
            deepDive:
                "당신은 ‘원칙’보다 ‘맥락’이 먼저입니다. 그래서 관계에서 유연하고 싸움을 키우지 않습니다. 하지만 상대가 원칙형이면 당신의 유연함을 ‘신뢰 부족’으로 느낄 수 있습니다. 핵심은 ‘모든 걸 유연하게’가 아니라 ‘어떤 건 절대 지킨다’의 최소 성역 설정.",
            triggerMap: ["상대가 강한 기준을 요구할 때", "사소한 거짓말/변경이 문제로 커질 때", "상대가 ‘가볍다’고 느낄 때"],
            innerMonologue: ["“이게 왜 그렇게 큰 문제지?”", "“상황이 그렇잖아.”", "“적당히 넘어가면 되는데…”"],
            relationshipLoop: "유연한 타협 → 상대는 불안/불신 → 상대 기준 강화 → 나는 답답/반발 → 평행선",
            whatYouNeed: ["핵심 가치 명문화(최소 성역)", "상대에게 ‘나는 이렇게 지킨다’ 선언", "유연함을 ‘회피’가 아닌 ‘선택’으로 설명"],
            whatPartnerNeeds: ["최소한의 확실한 기준", "변경 시 사전 합의", "가볍게 넘기지 않는 태도"],
            doDont: {
                do: ["‘이건 지킨다’ 3개 합의", "변경 전 공유", "상대 기준을 ‘예민함’으로 깎지 않기"],
                dont: ["모든 걸 상황 탓", "핵심 없는 타협", "상대를 예민하다고 몰기"]
            },
            scripts: [
                "“나는 유연한 편이지만, 이 3가지는 꼭 지키고 싶어.”",
                "“이번 변경은 미리 말했어야 했다. 다음부턴 먼저 공유할게.”",
                "“너한테 중요한 기준을 가볍게 보지 않을게.”"
            ],
            repairProtocol: [
                "1) 기준 충돌을 인정: “우린 중요하게 보는 게 달라”",
                "2) ‘절대 지킬 3개’만 정하고, 나머지는 유연하게",
                "3) 변경/타협은 ‘사전 공유’ 룰로 고정",
                "4) 오해 풀기 한 줄: “가볍게 보려는 게 아니라 방식이 다른 거야”"
            ],
            growthPath: "유연함을 유지하되 ‘최소 성역 3개’만 세우면, 가벼움이 아니라 신뢰로 보인다.",
            loveInsight: "유연함은 기름이다. 하지만 기둥이 있어야 집이 선다."
        },

        5: {
            title: "야심가형 승부사 (The Ambitious Competitor)",
            summary: "관계를 ‘주도/관리’하려는 힘이 강한 지배형",
            analysis: "리더십과 통제 욕구가 결합. ‘승리’가 목표가 되면 관계는 전장으로 변한다.",
            deepDive:
                "당신은 관계에서 영향력과 주도권을 중요하게 여깁니다. 에너지와 실행력도 좋아서 ‘잘 되는 관계’를 만들 수 있지만, 상대가 독립적으로 움직이려 할 때 통제로 반응할 수 있습니다. 이 타입의 핵심 과제는 ‘통제’ 대신 ‘협상’으로 이동하는 것.",
            triggerMap: ["상대가 내 통제 밖 선택을 할 때", "내 실수 인정이 필요한 순간", "주도권이 흔들릴 때"],
            innerMonologue: ["“내가 잡아야 안정적이야.”", "“지금 인정하면 진다.”", "“왜 내 말을 안 따라?”"],
            relationshipLoop: "주도권 시도 → 상대 저항/거리 → 통제 강화 → 신뢰 약화 → 힘겨루기",
            whatYouNeed: ["실수 인정=패배가 아님", "권력 대신 합의 프레임", "상대 자율성 보장"],
            whatPartnerNeeds: ["선택권", "존중", "감시/검열 없는 자유"],
            doDont: {
                do: ["‘내가 틀릴 수 있다’ 먼저 말하기", "결정은 2안 이상 제시(선택권)", "상대의 자율을 칭찬"],
                dont: ["힘으로 설득", "감정 단절로 처벌", "인정 회피"]
            },
            scripts: [
                "“내가 통제하려 했네. 네 선택권을 존중할게.”",
                "“내가 틀렸어. 인정하는 게 우리를 살리는 길이야.”",
                "“이건 우리가 같이 정하자. 너 의견이 필요해.”"
            ],
            repairProtocol: [
                "1) 통제 시도 인정: “내가 잡으려 했어”",
                "2) 선택권 반환: “너 선택은 뭐야? 두 안 중 고르자”",
                "3) 내 실수 1개는 먼저 인정(방어 금지)",
                "4) 재발 방지: ‘스톱워드’ 정하기(예: “지금 통제모드야”)"
            ],
            growthPath: "주도권을 ‘지배’가 아니라 ‘협상/보호’로 바꾸면, 카리스마가 신뢰로 전환된다.",
            loveInsight: "연애는 점령전이 아니라 서로에게 자리를 내어주는 협정이다."
        },

        6: {
            title: "게으른 천재 (The Idle Intuitive)",
            summary: "통찰은 높은데 실행이 낮아 ‘말뿐’으로 보이기 쉬움",
            analysis: "생각은 완벽하지만 행동이 늦다. 신뢰는 통찰이 아니라 반복 실행으로 쌓인다.",
            deepDive:
                "당신은 문제를 빠르게 파악하고 해결책도 잘 압니다. 그런데 실행이 늦거나 귀찮음으로 미뤄지면, 상대는 ‘의지 없음’으로 해석합니다. 이 타입의 핵심은 ‘큰 변화’가 아니라 ‘작은 즉시 행동’을 만드는 것.",
            triggerMap: ["반복되는 약속/개선 요구", "상대가 ‘말만’이라고 느낄 때", "해야 할 일이 많아 보일 때"],
            innerMonologue: ["“알아. 근데 지금은…”", "“나중에 한 번에 하면 되지.”", "“왜 이렇게 빨리 요구하지?”"],
            relationshipLoop: "통찰/약속 → 실행 미룸 → 상대 실망 → 잔소리/통제 → 더 귀찮음 → 악순환",
            whatYouNeed: ["마이크로 실행(5분 행동)", "즉시 결과가 보이는 습관", "약속을 ‘작게’ 쪼개기"],
            whatPartnerNeeds: ["말보다 행동", "작은 변화의 지속", "기대에 대한 현실적 합의"],
            doDont: {
                do: ["오늘 5분 행동 1개", "약속은 ‘언제’까지로", "작게 해도 바로 보여주기"],
                dont: ["‘다음에’ 반복", "큰 계획만 세우기", "지적받을 때만 움직이기"]
            },
            scripts: [
                "“지금 5분짜리로 바로 할게. 큰 변화보다 오늘 하나부터.”",
                "“이번 주 안에 이거 끝낼게. 날짜를 박자.”",
                "“말만 한 거 인정. 오늘부터 행동으로 보여줄게.”"
            ],
            repairProtocol: [
                "1) 말 대신 행동 1개를 ‘지금’ 하기(5분짜리)",
                "2) 약속은 ‘언제까지’로 날짜 박기",
                "3) 완료 후 짧게 보고(“했어”)",
                "4) 다음 행동 1개만 추가(욕심 금지)"
            ],
            growthPath: "큰 결심보다 ‘작은 즉시 실행’이 누적될 때, 통찰이 현실이 되고 신뢰가 생긴다.",
            loveInsight: "연애에서 매력은 천재성보다 ‘작은 실행’이다."
        },

        7: {
            title: "정직한 고지식가 (The Honest Traditionalist)",
            summary: "정직하고 안전하지만 변화에 약해 관계가 정체될 수 있음",
            analysis: "예측 가능성이 강점. 단점은 변화/새로움이 ‘위협’으로 번역되는 것.",
            deepDive:
                "당신은 거짓말을 싫어하고, 규칙과 루틴이 안정감을 줍니다. 그래서 ‘안전한 연인’으로 강점이 큽니다. 하지만 권태기나 변화가 필요한 시기에 ‘리스크’로만 해석하면 관계가 멈춥니다. 해결은 변화 자체를 ‘새 규칙’으로 편입하는 것.",
            triggerMap: ["갑작스런 계획 변경", "새로운 시도 요구", "관계의 실험(여행/새 패턴)", "불확실성"],
            innerMonologue: ["“굳이?”", "“안전하게 가자.”", "“변화는 리스크야.”"],
            relationshipLoop: "상대 변화 요구 → 나는 거부/유지 → 상대 답답/정체 → 거리/권태 → 더 경직",
            whatYouNeed: ["계획된 일탈(안전한 새로움)", "변화를 ‘규칙’으로 만들기", "상대 욕구를 리스크가 아닌 성장으로 보기"],
            whatPartnerNeeds: ["새로움에 대한 열린 태도", "‘해보자’ 최소 1회", "함께 설계하는 변화"],
            doDont: {
                do: ["매주 1개 새 시도", "새로움은 ‘작게’", "상대 제안을 ‘검토’로 받기"],
                dont: ["무조건 거절", "‘지금이 좋은데’로 종료", "상대 욕구를 철없는 것으로 폄하"]
            },
            scripts: [
                "“변화가 불안하긴 한데, 작게부터 해보자.”",
                "“이번 주는 새로운 거 하나만 시도해볼까?”",
                "“내가 안전을 선호해서 그래. 너한텐 성장이 중요하구나.”"
            ],
            repairProtocol: [
                "1) 변화 불안을 인정: “나 새로움이 좀 불안해”",
                "2) ‘작은 실험’ 1개만 선택(안전 버전)",
                "3) 실행 후 리뷰: “좋았던 점/힘든 점 1개씩”",
                "4) 다음 주 실험을 같이 설계"
            ],
            growthPath: "변화를 거부하지 말고 ‘작은 실험’으로 관리하면, 안전함을 잃지 않고도 관계가 성장한다.",
            loveInsight: "뿌리는 단단하되, 가지는 유연해야 한다."
        },

        8: {
            title: "번아웃된 완주자 (The Burned-out Finisher)",
            summary: "불안이 연료가 되는 실행가 — 헌신이 ‘비명’이 되기 쉬움",
            analysis: "완수는 강하지만 즐거움이 없다. ‘의무 헌신’이 빚처럼 느껴질 수 있다.",
            deepDive:
                "당신은 ‘못 하면 큰일 난다’는 압력으로 움직이는 경우가 많습니다. 그래서 성실하고 완주는 강하지만, 기쁨보다 피로가 남습니다. 관계에서도 최선을 다하지만, 지친 상태의 배려는 상대에게 ‘빚’처럼 느껴질 수 있어요.",
            triggerMap: ["과제/약속이 많을 때", "평가/비난이 예상될 때", "상대가 내 헌신을 당연시할 때"],
            innerMonologue: ["“해야 해.”", "“안 하면 욕먹어.”", "“나만 이렇게 하는 것 같아.”"],
            relationshipLoop: "불안 → 과잉 실행 → 피로/짜증 → ‘생색’/폭발 → 상대 반발 → 더 불안",
            whatYouNeed: ["휴식의 의무화", "완벽 기준 하향", "헌신을 ‘선택’으로 전환"],
            whatPartnerNeeds: ["즐거운 헌신", "부담 없는 배려", "감사와 역할 분담"],
            doDont: {
                do: ["할 일 50%만 하기", "휴식부터 일정에 넣기", "‘나 지금 지쳤어’ 공유"],
                dont: ["과잉 헌신 후 폭발", "‘내가 이렇게 하는데’ 공격", "휴식 죄책감"]
            },
            scripts: [
                "“나 지금 지쳤어. 오늘은 50%만 하자.”",
                "“내가 해주는 게 의무가 되면 힘들어. 역할을 나누자.”",
                "“고마워 한마디면 나는 훨씬 버틸 수 있어.”"
            ],
            repairProtocol: [
                "1) 피로 선고: “나 지금 지쳤어(수치로 0~10)”",
                "2) 오늘은 50%만 하기로 합의",
                "3) 역할 재배치: “이건 네가/이건 내가”",
                "4) 마지막에 감사 교환(강제): “고마워” 1번씩"
            ],
            growthPath: "헌신의 양을 줄이고 ‘지속 가능한 리듬’을 만들면, 사랑이 의무가 아니라 즐거움으로 남는다.",
            loveInsight: "지친 친절은 상대에게 빚처럼 느껴질 수 있다."
        },

        9: {
            title: "기회주의적 생존가 (The Opportunistic Survivor)",
            summary: "보상에 민감한 추진형 — 온도 차가 신뢰를 무너뜨림",
            analysis: "필요할 땐 뜨겁고, 손해면 빠진다. 장기 신뢰 회로를 설계해야 한다.",
            deepDive:
                "당신은 보상이 분명할 때 추진력이 폭발합니다. 하지만 손해가 예상되면 방어적으로 빠져나올 수 있습니다. 연애에서 이 패턴이 반복되면 상대는 ‘예측 불가’로 느끼고 미래 설계를 두려워합니다.",
            triggerMap: ["내가 손해 보는 상황", "갈등에서 불리함", "관계가 익숙해져 보상이 줄 때", "책임이 늘어날 때"],
            innerMonologue: ["“이건 손해야.”", "“왜 내가 해야 하지?”", "“지금은 빠지는 게 맞아.”"],
            relationshipLoop: "초반 과투자 → 익숙해짐 → 투자 급감 → 상대 배신감 → 갈등에서 이탈 → 신뢰 붕괴",
            whatYouNeed: ["장기 보상(신뢰) 재프레이밍", "일관성 있는 최소 투자", "불리해도 대화에 남기"],
            whatPartnerNeeds: ["예측 가능성", "갈등에서 이탈하지 않는 태도", "일관된 애정 신호"],
            doDont: {
                do: ["‘최소 지속 행동’ 3개 고정", "불리해도 대화는 남기", "관계 장기 목표 설정"],
                dont: ["필요할 때만 잘하기", "손해면 잠수", "관계를 거래처럼 운영"]
            },
            scripts: [
                "“내가 불리하다고 도망치면 신뢰가 깨져. 대화는 남을게.”",
                "“나는 최소한 이 3가지는 꾸준히 할게.”",
                "“단기 이익보다 신뢰가 더 큰 보상이라는 걸 배우는 중이야.”"
            ],
            repairProtocol: [
                "1) 온도 차 인정: “내가 뜨겁다 식었다 했어”",
                "2) ‘최소 지속 행동 3개’ 고정(매주 지킬 것)",
                "3) 갈등에서 ‘이탈 금지’ 룰 합의",
                "4) 2주 단위로 점검(지속 여부 체크)"
            ],
            growthPath: "단기 손익 대신 ‘신뢰가 장기 보상’이라는 프레임을 세우면, 영리함이 관계를 살리는 방향으로 바뀐다.",
            loveInsight: "영리함은 순간을 모면하지만, 진정성은 미래를 만든다."
        },

        10: {
            title: "회피형 몽상가 (The Evasive Dreamer)",
            summary: "현실 직면을 피하고 ‘좋은 상상’으로 버티는 타입",
            analysis: "갈등을 현실로 처리하지 않으면 쓰레기가 쌓인다. ‘작은 패배 경험’이 필요하다.",
            deepDive:
                "당신은 불편한 대화를 ‘위험’으로 해석하고 회피로 안전을 확보하려 합니다. 스스로는 평화를 추구하지만, 상대는 ‘대화 불가능’으로 느낍니다. 핵심은 큰 변화가 아니라 ‘오늘 1개의 불편함을 말하는’ 연습입니다.",
            triggerMap: ["갈등 직면", "실수 인정 요구", "책임 대화", "상대의 분노/압박"],
            innerMonologue: ["“지금은 말하면 망해.”", "“시간 지나면 괜찮아질 거야.”", "“내가 피해자야…”"],
            relationshipLoop: "문제 발생 → 회피/잠수 → 미해결 누적 → 신뢰 하락 → 상대 폭발/이별 → 나는 ‘어쩔 수 없었다’",
            whatYouNeed: ["하루 1회 현실 체크(작은 대화)", "작은 실수 인정 훈련", "잠수 대신 ‘시간 약속’"],
            whatPartnerNeeds: ["대화의 창", "문제 처리 의지", "책임 인정"],
            doDont: {
                do: ["‘지금은 어렵지만 언제’ 말하기", "사과 1문장이라도 즉시", "작은 패배를 경험"],
                dont: ["잠수", "피해자 프레임 고정", "현실 부정"]
            },
            scripts: [
                "“지금은 겁나서 말이 안 나와. 대신 오늘 밤 10시에 꼭 얘기하자.”",
                "“내가 피한 거 맞아. 미안해. 지금부터라도 정리하자.”",
                "“작은 것부터 인정할게. 이건 내 잘못이야.”"
            ],
            repairProtocol: [
                "1) 잠수 금지: 못 하겠으면 ‘언제’만 말하기",
                "2) 사과 1문장(변명 없이)",
                "3) 오늘 1개만 해결",
                "4) 다음번엔 ‘30분 대화’ 약속(루틴화)"
            ],
            growthPath: "큰 용기가 아니라 ‘작은 직면’을 매일 1번만 하면, 회피 패턴이 현실 대응 패턴으로 바뀐다.",
            loveInsight: "눈을 감는다고 폭풍이 사라지진 않는다."
        },

        11: {
            title: "철저한 자기관리자 (The Self-Controller)",
            summary: "감정을 이기는 질서 — 단, 인간미가 부족하게 보일 수 있음",
            analysis: "자기 통제가 강해 안정적이지만, 너무 완벽하면 상대가 위축된다.",
            deepDive:
                "당신은 감정이 올라와도 ‘관리’로 처리합니다. 그래서 관계가 깔끔하고, 큰 사고가 적습니다. 하지만 늘 완벽하면 상대는 ‘나만 부족한가’라는 비교 수치심을 느낄 수 있고, 친밀감이 줄어듭니다.",
            triggerMap: ["상대의 감정 폭발", "즉흥적 요구", "내 질서가 깨질 때", "예측 불가능성"],
            innerMonologue: ["“흐트러지면 안 돼.”", "“정리해야 해.”", "“감정은 관리 대상이야.”"],
            relationshipLoop: "나는 항상 정돈 → 상대는 위축/거리 → 더 감정 숨김 → 친밀감 감소",
            whatYouNeed: ["의도적 빈틈", "감정의 날것 5% 공개", "상대의 미숙함을 품는 태도"],
            whatPartnerNeeds: ["인간미", "나도 괜찮다는 신호", "함께 망가질 수 있는 시간"],
            doDont: {
                do: ["가끔 계획 망치기 허용", "사소한 투정/응석 허용", "‘나도 약해’ 한 줄"],
                dont: ["항상 완벽", "상대 감정 교정/수정", "혼자만 성숙한 척"]
            },
            scripts: [
                "“나도 완벽하진 않아. 오늘은 그냥 기대고 싶다.”",
                "“지금은 정리보다 같이 느끼는 게 필요하네.”",
                "“나도 흔들려. 그래서 더 관리하려 했어.”"
            ],
            repairProtocol: [
                "1) 취약함 1줄 공개: “나도 지금 흔들려”",
                "2) 상대 감정은 ‘수정’ 말고 ‘인정’만",
                "3) 10분간 ‘노-솔루션’(해결 금지)으로 같이 있기",
                "4) 그 다음에 정리/계획"
            ],
            growthPath: "완벽함을 조금 내려놓고 ‘안전한 빈틈’을 만들면, 상대가 더 가까이 들어온다.",
            loveInsight: "사랑은 때때로 무질서 속에서 꽃핀다."
        },

        12: {
            title: "권태로운 동반자 (The Languid Partner)",
            summary: "동력이 낮아 관계를 ‘부유’시키는 타입 — 방관이 이별로 보일 수 있음",
            analysis: "갈등을 해결하기보다 시간에 맡긴다. 작은 목표로 도파민 스파크가 필요하다.",
            deepDive:
                "당신은 큰 갈등을 피하고, 에너지 소모를 최소화하려 합니다. 문제는 ‘아무것도 하지 않음’이 상대에게는 ‘관심 없음’으로 번역된다는 것. 이 타입은 거창한 변화보다 ‘작은 공동 목표’가 관계를 살립니다.",
            triggerMap: ["관계가 익숙해졌을 때", "노력 요구", "갈등 해결 요구", "반복되는 권태"],
            innerMonologue: ["“귀찮아…”", "“시간 지나면 괜찮겠지.”", "“굳이 지금?”"],
            relationshipLoop: "권태 → 방치 → 상대 불안/분노 → 더 회피 → 관계 온도 하락 → 이별",
            whatYouNeed: ["작은 공동 목표", "주 1회 ‘데이트 미션’", "관계 관리 루틴(30분 체크인)"],
            whatPartnerNeeds: ["명확한 의지 표현", "작은 행동의 지속", "갈등을 외면하지 않는 태도"],
            doDont: {
                do: ["작은 성취 만들기", "주1회 체크인", "갈등은 ‘언제’ 풀지 정하기"],
                dont: ["방치", "무응답", "상대가 다 하게 두기"]
            },
            scripts: [
                "“요즘 내가 느슨했어. 주 1회는 내가 데이트를 설계할게.”",
                "“지금은 귀찮아서 피하고 싶지만, 우리를 위해 30분만 얘기하자.”",
                "“작은 목표 하나 같이 하자. 우리 관계에 불을 붙이자.”"
            ],
            repairProtocol: [
                "1) 방치 인정: “요즘 내가 느슨했어”",
                "2) 주 1회 ‘내가 준비하는 데이트 미션’ 고정",
                "3) 갈등은 ‘언제 말할지’부터 정하기(회피 대신 약속)",
                "4) 2주 후 리뷰(지속/온도 체크)"
            ],
            growthPath: "관계도 에너지가 필요하다. 작은 목표+작은 성취를 만들면 저출력도 충분히 살아난다.",
            loveInsight: "방관은 평화가 아니라, 천천히 진행되는 이별이다."
        }
    },

    en: {
        1: {
            title: "The Pillar of Principles",
            summary: "Principles aren’t preferences—they’re identity",
            analysis: "Clear standards + strong execution. Risk: mistakes get translated as betrayal, creating a suffocating audit atmosphere.",
            deepDive:
                "For you, rules are structural. Keeping promises isn’t virtue—it’s baseline. A small violation can feel like a trust fracture, not a minor error. Your strength is reliability. Your risk is turning the relationship into a courtroom when standards tighten too hard.",
            triggerMap: ["Trivial lies", "Broken promises", "“It’s not a big deal” rationalization", "Small unethical/manner breaches"],
            innerMonologue: ["“This isn’t a mistake—it’s a standards issue.”", "“Trust doesn’t crack twice.”", "“Did they take me lightly?”"],
            relationshipLoop: "Violation detected → internal trust score drops → emotional distance → partner feels sudden coldness → ‘audit’ mood becomes the norm",
            whatYouNeed: ["Separate context from malice", "Run principles as agreements, not laws", "Offer repair windows before verdicts"],
            whatPartnerNeeds: ["A chance to explain", "Distinction between mistake vs betrayal", "Warmth before judgment"],
            doDont: {
                do: ["Clarify intent before concluding", "Name your standard + feeling", "Create anti-repeat agreements"],
                dont: ["Turn mistakes into character trials", "Punish with silence", "Force your standard as absolute truth"]
            },
            scripts: [
                "“This matters to me. Can you tell me why you chose that?”",
                "“I care about principles—so I want to understand before judging.”",
                "“If it’s a mistake, we can repair. If it repeats, we need new rules.”"
            ],
            repairProtocol: [
                "1) Start with 2 lines: your standard + your feeling",
                "2) Ask ONE intent question: “Why did you do that?”",
                "3) Agree on ONE prevention rule for next time",
                "4) Close with reassurance: “I want to rebuild trust.”"
            ],
            growthPath: "Slow down verdicts and use a consistent sequence: clarify → agree → reconnect. You keep standards without freezing the relationship.",
            loveInsight: "Honesty is noble—but love isn’t a courtroom."
        },

        2: {
            title: "The Bulldozer",
            summary: "High-output forward force—fixes fast, can pressure partners",
            analysis: "Execution and improvement are strengths. Risk: your pace becomes the standard and crushes your partner’s autonomy.",
            deepDive:
                "You treat conflict as a task to solve. You push for closure and invest massive energy into “making it better.” That’s powerful—but if your partner can’t match the pace, they may feel criticized, inadequate, or trapped.",
            triggerMap: ["Unresolved ambiguity", "Slow responses", "Repeated issues", "Perceived lack of effort"],
            innerMonologue: ["“Let’s fix this now.”", "“Why so slow?”", "“We should be doing more.”"],
            relationshipLoop: "Conflict → you go into solve mode → partner feels pressured → defensiveness rises → speed mismatch becomes emotional damage",
            whatYouNeed: ["Pace-matching", "Validation before solutions", "Respect recovery time"],
            whatPartnerNeeds: ["Collaboration not pressure", "Step-by-step agreements", "Permission to move slowly"],
            doDont: {
                do: ["Stabilize first, solve second", "Ask their pace", "Solve one item at a time"],
                dont: ["Compare effort (‘why not like me?’)", "Demand instant conclusions", "Equate effort with love"]
            },
            scripts: [
                "“I want to solve fast—what pace works for you? I’ll match it.”",
                "“Let’s stabilize first. We can solve in 30 minutes.”",
                "“I’m getting urgent—I don’t want to pressure you.”"
            ],
            repairProtocol: [
                "1) Name your urgency: “I’m getting rushed.”",
                "2) Ask their pace: “What pace works for you?”",
                "3) Solve ONE item today; schedule the rest",
                "4) End with appreciation: “Thanks for meeting me halfway.”"
            ],
            growthPath: "Add pace-matching to your power. Then your drive becomes leadership—not pressure.",
            loveInsight: "Running alone is a race. Love is walking together."
        },

        3: {
            title: "The Anxious Perfectionist",
            summary: "High standards + high fear—avoidance and guilt loops",
            analysis: "You want to do it right, but fear makes execution collapse. The loop is: delay → guilt → burnout.",
            deepDive:
                "Your standards are high, but the cost of failure feels massive. That makes you postpone decisions, avoid hard talks, and then punish yourself afterward. You look conscientious on the outside, but inside you live on an imaginary witness stand.",
            triggerMap: ["Facing conflict", "Being corrected", "Risk of disappointing others", "Situations that feel like judgment"],
            innerMonologue: ["“If I fail, it’s over.”", "“If I talk now, I’ll ruin it.”", "“I must be perfect.”"],
            relationshipLoop: "Issue appears → anxiety spikes → avoidance/delay → guilt accumulates → self-attack → less capacity to repair",
            whatYouNeed: ["‘Good enough’ mindset", "Small wins through micro-actions", "Reframe conflict as calibration, not failure"],
            whatPartnerNeeds: ["Safe feedback", "Assurance you won’t be discarded for imperfection", "Consistency via small promises"],
            doDont: {
                do: ["Name anxiety out loud", "Schedule a short talk window", "Do one tiny repair action today"],
                dont: ["Wait for perfect timing", "Avoid then only self-blame", "Interpret feedback as sentencing"]
            },
            scripts: [
                "“I’m anxious and might stumble. Give me 10 minutes, then I’ll talk.”",
                "“I can’t say it perfectly, but I want to repair. One step at a time.”",
                "“If I avoid, guilt grows—so I’m doing a small fix today.”"
            ],
            repairProtocol: [
                "1) Name the feeling: “I’m anxious; I might stumble.”",
                "2) Use a 15-minute timer talk",
                "3) Resolve ONE small thing only",
                "4) Log the win: “We made progress today.”"
            ],
            growthPath: "Micro-wins beat perfect plans. Small completion reduces fear and restores execution.",
            loveInsight: "Your torment isn’t their judgment—it’s the tribunal you built inside."
        },

        4: {
            title: "The Flexible Pragmatist",
            summary: "Context-first, compromise-strong—needs clear core values to build trust",
            analysis: "Flexibility is your gift. Risk: it reads as lightness if no ‘minimum sanctuary’ exists.",
            deepDive:
                "You optimize for context. You reduce friction and find workable compromises. But with a principled partner, your flexibility can look like weak integrity. The solution is not rigidity—it's defining a few non-negotiables.",
            triggerMap: ["Partner demands strict standards", "Minor lies/changes become big issues", "Accusations of being ‘too casual’"],
            innerMonologue: ["“Why is this so big?”", "“Context matters.”", "“We can just adjust.”"],
            relationshipLoop: "You compromise → partner feels unsafe → partner tightens standards → you feel constrained → stalemate",
            whatYouNeed: ["Codify core values", "Explain flexibility as choice, not avoidance", "Pre-announce changes"],
            whatPartnerNeeds: ["A few stable rules", "Advance notice of changes", "Respect for their standards"],
            doDont: {
                do: ["Agree on 3 non-negotiables", "Notify before changing plans", "Don’t label them ‘too sensitive’"],
                dont: ["Context as a universal excuse", "Flex everything", "Invalidate their standards"]
            },
            scripts: [
                "“I’m flexible, but these three things I’ll always keep.”",
                "“I should’ve told you earlier. Next time I’ll notify first.”",
                "“Your standards matter. I won’t treat them lightly.”"
            ],
            repairProtocol: [
                "1) Acknowledge value mismatch",
                "2) Set 3 non-negotiables; flex the rest",
                "3) Create a ‘notify-before-change’ rule",
                "4) Clarify intent: “I’m not careless—my style is contextual.”"
            ],
            growthPath: "Keep flexibility, add pillars. Three sanctuaries turn ‘lightness’ into trust.",
            loveInsight: "Flexibility is oil—but a house needs pillars."
        },

        5: {
            title: "The Ambitious Competitor",
            summary: "Leadership and control drive—turns love into a power game if unchecked",
            analysis: "Strong initiative. Risk: control replaces consent; admitting faults feels like defeat.",
            deepDive:
                "You value influence and initiative. You can build a ‘successful relationship,’ but when your partner acts outside your control, you may respond with power logic. The upgrade is moving from control to negotiation.",
            triggerMap: ["Partner independence", "Moments requiring your admission of fault", "Loss of initiative"],
            innerMonologue: ["“If I hold it, it stays stable.”", "“If I admit, I lose.”", "“Why won’t they follow?”"],
            relationshipLoop: "Control attempt → partner resists → you tighten control → trust erodes → power struggle",
            whatYouNeed: ["Admitting fault is not defeat", "Replace power with agreements", "Protect partner autonomy"],
            whatPartnerNeeds: ["Choice", "Respect", "Freedom from surveillance"],
            doDont: {
                do: ["Start with ‘I might be wrong’", "Offer options", "Praise autonomy"],
                dont: ["Dominate to resolve", "Punish via emotional cutoff", "Avoid admissions"]
            },
            scripts: [
                "“I tried to control. I’ll respect your choice.”",
                "“I was wrong. Admitting it is how we win together.”",
                "“Let’s decide this as a team.”"
            ],
            repairProtocol: [
                "1) Admit control: “I tried to take over.”",
                "2) Return choice: offer options and let them pick",
                "3) Admit one fault first (no defense)",
                "4) Set a stop-word for control-mode"
            ],
            growthPath: "Shift from control to negotiation. That’s how dominance becomes secure leadership.",
            loveInsight: "Love is not conquest. It’s making room for each other."
        },

        6: {
            title: "The Idle Intuitive",
            summary: "High insight, low follow-through—becomes ‘all talk’ without micro-action",
            analysis: "You see everything, but action lags. Trust is built by repeated small execution.",
            deepDive:
                "You understand the problem and the solution quickly. But execution gets delayed by friction. Over time, ‘next time’ kills credibility. The fix is micro-actions that prove intent today.",
            triggerMap: ["Repeated improvement requests", "Partner says ‘you only talk’", "Tasks feel too big"],
            innerMonologue: ["“I know… later.”", "“I’ll do it in one big push.”", "“Why the rush?”"],
            relationshipLoop: "Promise → delay → partner disappointment → nagging → more friction → worse delay",
            whatYouNeed: ["5-minute actions", "Visible small habits", "Break promises into tiny steps"],
            whatPartnerNeeds: ["Action over words", "Consistency", "Realistic commitments"],
            doDont: {
                do: ["Do one 5-minute action now", "Put dates on promises", "Show progress immediately"],
                dont: ["Repeat ‘later’", "Make only big plans", "Move only when criticized"]
            },
            scripts: [
                "“I’ll do a 5-minute version right now.”",
                "“Let’s put a date on it: I’ll finish by Friday.”",
                "“I agree it sounded like talk. I’ll prove it with action.”"
            ],
            repairProtocol: [
                "1) Do ONE action now (5 minutes)",
                "2) Put a date on the promise",
                "3) Report completion briefly (“Done.”)",
                "4) Add only ONE next step"
            ],
            growthPath: "Small immediate actions convert insight into credibility.",
            loveInsight: "In love, small execution beats idle genius."
        },

        7: {
            title: "The Honest Traditionalist",
            summary: "Safe and honest—risk: stagnation when change is needed",
            analysis: "Predictability builds trust; rigidity breeds boredom. Planned novelty is the patch.",
            deepDive:
                "Rules and routines calm you. You’re trustworthy and consistent. But relationships need evolution; if you treat novelty as threat, intimacy stagnates. Your best upgrade is ‘planned deviation’—safe experiments.",
            triggerMap: ["Sudden plan changes", "Requests for novelty", "Uncertainty", "Relationship experiments"],
            innerMonologue: ["“Do we have to?”", "“Let’s keep it safe.”", "“Change is risk.”"],
            relationshipLoop: "Partner asks change → you refuse → partner feels stuck → distance grows → you become more rigid",
            whatYouNeed: ["Planned deviation", "Small novelty as a rule", "See partner’s desire as growth"],
            whatPartnerNeeds: ["Openness", "At least one ‘try’", "Co-designed changes"],
            doDont: {
                do: ["Try one new thing weekly", "Keep novelty small", "Treat proposals as ‘reviewable’"],
                dont: ["Auto-refuse", "End with ‘it’s fine’", "Mock their desire"]
            },
            scripts: [
                "“Change makes me anxious, but we can try a small version.”",
                "“One new thing this week—small and safe.”",
                "“I prefer stability. You need growth. Let’s balance.”"
            ],
            repairProtocol: [
                "1) Name change anxiety",
                "2) Choose ONE safe experiment",
                "3) Review: one good + one hard point",
                "4) Co-design next week’s experiment"
            ],
            growthPath: "Treat change as a managed experiment, not a threat.",
            loveInsight: "Firm roots, flexible branches."
        },

        8: {
            title: "The Burned-out Finisher",
            summary: "Executes through anxiety—devotion turns into resentment if rest is missing",
            analysis: "You complete everything, but joy disappears. Exhausted kindness becomes debt.",
            deepDive:
                "Your engine runs on pressure. You finish, keep promises, and sacrifice. But when fatigue accumulates, your giving carries pain—then explodes as “why don’t you appreciate me?” The fix is mandated rest and less-than-perfect completion.",
            triggerMap: ["Too many obligations", "Expected criticism", "Feeling taken for granted"],
            innerMonologue: ["“I must.”", "“If I fail, I’m judged.”", "“I’m the only one carrying this.”"],
            relationshipLoop: "Pressure → over-execution → fatigue/irritation → credit-demand → conflict → more pressure",
            whatYouNeed: ["Mandatory rest", "Lower perfection demands", "Turn devotion into choice"],
            whatPartnerNeeds: ["Joyful giving", "Shared load", "Clear appreciation"],
            doDont: {
                do: ["Do 50% today", "Schedule rest first", "Say ‘I’m tired’ early"],
                dont: ["Overgive then explode", "Weaponize sacrifice", "Guilt-rest cycles"]
            },
            scripts: [
                "“I’m tired. Today I can do 50%, not 100.”",
                "“If this becomes my duty, I burn out. Let’s split it.”",
                "“A simple ‘thank you’ helps me a lot.”"
            ],
            repairProtocol: [
                "1) Declare fatigue (0–10 scale)",
                "2) Agree on 50% effort today",
                "3) Reassign roles clearly",
                "4) Exchange one explicit ‘thank you’ each"
            ],
            growthPath: "Build a sustainable rhythm. Less perfection, more longevity.",
            loveInsight: "Exhausted kindness feels like debt."
        },

        9: {
            title: "The Opportunistic Survivor",
            summary: "Reward-sensitive pusher—hot/cold swings damage trust",
            analysis: "High investment when reward is clear; withdrawal when loss is expected. Needs long-term trust framing.",
            deepDive:
                "You surge when payoff is visible and retreat when it isn’t. In relationships, that creates temperature swings that feel like betrayal. The repair is building a minimum consistent investment—especially in conflict.",
            triggerMap: ["Situations where you might lose", "Conflict when you’re ‘wrong’", "When novelty wears off"],
            innerMonologue: ["“This is a loss.”", "“Why should I?”", "“Exit is smarter.”"],
            relationshipLoop: "Early over-invest → familiarity → investment drops → partner distrust → you exit in conflict → future fear",
            whatYouNeed: ["Trust as long-term reward", "Minimum consistent behaviors", "Stay present in conflict"],
            whatPartnerNeeds: ["Predictability", "No disappearing under pressure", "Consistent affection signals"],
            doDont: {
                do: ["Fix 3 consistent behaviors", "No-exit rule in conflict", "Set long-term relationship goals"],
                dont: ["Only show up when needed", "Ghost when it costs you", "Run it like a transaction"]
            },
            scripts: [
                "“Even if it costs me, I won’t leave the conversation.”",
                "“These three things I’ll do consistently.”",
                "“Trust is the bigger reward. I’m rebuilding that.”"
            ],
            repairProtocol: [
                "1) Admit hot/cold swings",
                "2) Lock 3 consistent behaviors weekly",
                "3) No-exit rule during conflict",
                "4) Review every 2 weeks"
            ],
            growthPath: "Reframe trust as the long-term reward; then intelligence fuels consistency.",
            loveInsight: "Cleverness dodges moments; sincerity builds futures."
        },

        10: {
            title: "The Evasive Dreamer",
            summary: "Reality resistance is low—escape feels safer than repair",
            analysis: "Avoidance prevents pain short-term and destroys trust long-term. Needs ‘small defeat’ practice.",
            deepDive:
                "You protect yourself by escaping discomfort. You may ghost, delay, or deny. But unresolved issues pile up and rot the bond. The upgrade is one small uncomfortable conversation per day and time-bound pauses instead of disappearing.",
            triggerMap: ["Direct conflict", "Requests to admit mistakes", "Responsibility talks", "Partner anger/pressure"],
            innerMonologue: ["“If I talk, it gets worse.”", "“Time will fix it.”", "“I’m the victim.”"],
            relationshipLoop: "Issue → escape → accumulation → trust loss → breakup → self-victim story",
            whatYouNeed: ["Daily reality check", "Small admissions", "Time-bound pauses"],
            whatPartnerNeeds: ["A dialogue window", "Repair attempts", "Accountability"],
            doDont: {
                do: ["Say ‘not now, but at 10pm’", "Apologize one sentence immediately", "Practice small losses safely"],
                dont: ["Ghosting", "Victim lock-in", "Reality denial"]
            },
            scripts: [
                "“I’m overwhelmed. Not disappearing—let’s talk at 10.”",
                "“I avoided it. I’m sorry. Let’s fix one thing now.”",
                "“This one is on me.”"
            ],
            repairProtocol: [
                "1) No ghosting—if you can’t talk, set a time",
                "2) One clean apology line (no excuses)",
                "3) Fix ONE item today",
                "4) Schedule a 30-minute check-in"
            ],
            growthPath: "Daily micro-confrontation replaces avoidance with real resilience.",
            loveInsight: "Closing your eyes doesn’t remove storms."
        },

        11: {
            title: "The Self-Controller",
            summary: "Steel-like self-control—can feel ‘inhuman’ if perfection never breaks",
            analysis: "Order builds stability. Excess order builds distance. Needs intentional gaps and warmth.",
            deepDive:
                "You override impulses and keep your system tidy. That’s a strength. But if you never show cracks, your partner feels small, ashamed, and emotionally alone. Intimacy grows through safe imperfection.",
            triggerMap: ["Partner emotional chaos", "Unplanned demands", "Disorder", "Uncertainty"],
            innerMonologue: ["“Don’t break.”", "“Control it.”", "“Emotions are manageable.”"],
            relationshipLoop: "You stay perfect → partner hides mess → less intimacy → more distance",
            whatYouNeed: ["Intentional gaps", "5% raw emotion", "Acceptance of partner messiness"],
            whatPartnerNeeds: ["Human warmth", "Permission to be imperfect", "Shared chaos moments"],
            doDont: {
                do: ["Say one vulnerable line", "Allow small plan-breaks", "Validate before optimizing"],
                dont: ["Be perfect always", "Correct feelings", "Act ‘above’ emotions"]
            },
            scripts: [
                "“I’m not perfect either. Today I just want comfort.”",
                "“Let’s not fix it—let’s just be here a minute.”",
                "“I was controlling because I was scared.”"
            ],
            repairProtocol: [
                "1) Share one vulnerability line",
                "2) Validate, don’t correct",
                "3) 10 minutes of ‘no solutions’ presence",
                "4) Then plan together"
            ],
            growthPath: "Intentional imperfection builds intimacy. A small crack invites closeness.",
            loveInsight: "Love often blooms in gentle disorder."
        },

        12: {
            title: "The Languid Partner",
            summary: "Low drive → relationship drifts; partners interpret it as abandonment",
            analysis: "Avoids effort and conflict. Patch: shared goals + weekly rituals that create dopamine sparks.",
            deepDive:
                "You minimize energy use and wait for time to solve problems. Partners read that as ‘you don’t care.’ The rescue is tiny shared goals and rituals that create novelty and small wins.",
            triggerMap: ["Familiarity/monotony", "Requests for effort", "Conflict resolution demands"],
            innerMonologue: ["“Ugh…”", "“It’ll pass.”", "“Do we have to now?”"],
            relationshipLoop: "Boredom → neglect → partner distress → more avoidance → temperature drops → breakup",
            whatYouNeed: ["Small shared goals", "Weekly date mission", "30-min relationship check-in"],
            whatPartnerNeeds: ["Clear commitment signal", "Consistent small actions", "No avoidance in conflict"],
            doDont: {
                do: ["Weekly ritual", "One small win together", "Schedule conflict talk time"],
                dont: ["Drift", "Silence", "Let partner carry everything"]
            },
            scripts: [
                "“I’ve been drifting. I’ll plan one date a week.”",
                "“I want to avoid this, but let’s talk 30 minutes for us.”",
                "“Let’s pick one shared goal to bring the spark back.”"
            ],
            repairProtocol: [
                "1) Admit drift",
                "2) Weekly ‘date mission’ you lead",
                "3) Schedule conflict talks instead of avoiding",
                "4) Review after 2 weeks"
            ],
            growthPath: "Spark comes from novelty + small wins. Rituals create energy even in low-drive systems.",
            loveInsight: "Neglect isn’t peace. It’s a slow breakup."
        }
    }
};
